import { AttachmentIcon, PreloaderIcon } from '../../../../common/ui/icons';
import { ChangeEvent, useState } from 'react';
import { showToast } from '../../../../common/domain/toast-provider';
import { uploadWikiFile } from '../../data/wiki-data-service';
import { useNavigate } from 'react-router-dom';
import { useWikiStore } from '../../data/wiki-store';

const WikiMenuUploadButton = () => {

    const [isLoading, setLoading] = useState(false);

    const wikiSelectedPath = useWikiStore(store => store.wikiSelectedPath);

    const navigate = useNavigate();

    const uploadFileHandler = async (evt: ChangeEvent<HTMLInputElement>) => {

        if(!evt.target.files || evt.target.files.length <= 0){
            showToast('Upload error.');
            return;
        }

        const file = evt.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('selectedFile', wikiSelectedPath);

        setLoading(true);
        const response = await uploadWikiFile(formData as FormData);
        setLoading(false);

        if(!response || !response.isValid) {
            showToast('Upload error.');
        }
        else{
            showToast('Upload OK.', false);
        }

        const newPath = response.filePath.replace('/api/wiki/get-file?file_path=', '');
        navigate(`/wiki${ newPath }`);
    };

    return (
        <label
            title="Upload File"
            className="ml-4 flex">

            {
                !isLoading &&
                <AttachmentIcon size={ 25 } color="#94A3B8" />
            }

            {
                isLoading &&
                <PreloaderIcon size={ 20 } color={ '#94A3B8' } />
            }

            <input
                onChange={ uploadFileHandler }
                className="hidden"
                type="file" />
        </label>
    )
};

export default WikiMenuUploadButton;